import './track-comment.sass'

import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Translate, I18n } from 'react-redux-i18n';

import Checkbox from 'controls/checkbox/Checkbox';
import ContentLoader from 'controls/content-loader/ContentLoader';

import Admission from 'components/track-events/admission/Admission';

import request from 'actions/request';

class TrackComment extends Component {
  constructor(props) {
    super(props);

    this.textarea = null;

    this.state = {
      fetched: false,
      comment: '',
      operatorAdmitted: false,
      vehicleAllowed: false,
      generalAdmission: false
    };
  }

  componentDidMount() {
    this.props.request(
      ['trackComment', 'get'],
      'GET',
      null,
      { trackId: this.props.trackId}
    ).then((resp) => {
      this.setState({
        fetched: true,
        comment: resp.comment,
        operatorAdmitted: resp.operatorAdmitted,
        vehicleAllowed: resp.vehicleAllowed,
        generalAdmission: resp.generalAdmission
      });
    });
  }

  handleChangeComment(event) {
    this.setState({ comment: event.target.value });
  }

  handleChangeCommanderAdmitted() {
    this.setState({ operatorAdmitted: !this.state.operatorAdmitted });
  }

  handleChangeAircraftAllowed() {
    this.setState({ vehicleAllowed: !this.state.vehicleAllowed });
  }

  handleChangeGeneralAdmission() {
    this.setState({ generalAdmission: !this.state.generalAdmission });
  }

  handleSave() {
    this.setState({ fetched: null });
    this.props.request(
      ['trackComment', 'set'],
      'POST',
      null,
      {
        trackId: this.props.trackId,
        comment: this.state.comment,
        operatorAdmitted: this.state.operatorAdmitted,
        vehicleAllowed: this.state.vehicleAllowed,
        generalAdmission: this.state.generalAdmission
      }
    ).then((resp) => {
      this.setState({ fetched: true });
    });
  }

  renderButton() {
    if (this.state.fetched === null) {
      return <ContentLoader margin={ 1 } size={ 30 } border= { 3 } />;
    }

    if (this.props.userRole === 'admin') {
      return (<button
        className='btn btn-default'
        onClick={ this.handleSave.bind(this) }
      >
        <Translate value='trackEvents.trackComment.save'/>
      </button>);
    }

    return null;
  }

  render() {
    if (this.state.fetched === false) {
      return null
    }

    return (
      <div className='track-events-track-comment'>
        <div className='track-events-track-comment__container'>
          <div className='row'>
            <textarea
              className='track-events-track-comment__textarea form-control'
              disabled={ ((this.props.userRole !== 'admin') ? 'disabled' : '') }
              value={ ((this.state.comment === null) ? '' : this.state.comment) }
              onChange={ this.handleChangeComment.bind(this) }
            >
            </textarea>
          </div>
          <div className='track-events-track-comment__admissions-row row'>
            <div className='col-md-10'>
              <Admission
                label={ I18n.t('trackEvents.trackComment.operatorAdmitted') }
                disabled={ (this.props.userRole !== 'admin') }
                checkstate={ this.state.operatorAdmitted }
                changeCheckState={ this.handleChangeCommanderAdmitted.bind(this) }
              />
              <Admission
                label={ I18n.t('trackEvents.trackComment.vehicleAllowed') }
                disabled={ (this.props.userRole !== 'admin') }
                checkstate={ this.state.vehicleAllowed }
                changeCheckState={ this.handleChangeAircraftAllowed.bind(this) }
              />
              <Admission
              label={ I18n.t('trackEvents.trackComment.generalAdmission') }
                disabled={ (this.props.userRole !== 'admin') }
                checkstate={ this.state.generalAdmission }
                changeCheckState={ this.handleChangeGeneralAdmission.bind(this) }
              />
            </div>
            <div className='track-events-track-comment__btn-col col-md-2'>
              {  this.renderButton() }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

TrackComment.propTypes = {
  trackId: PropTypes.number.isRequired
};

function mapStateToProps(state) {
  return {
    userRole: state.user.role
  };
}

function mapDispatchToProps(dispatch) {
  return {
    request: bindActionCreators(request, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TrackComment);
